import React, { useState } from "react";
import SiteHead from "../component/head/SiteHead";
import Link from "next/link";
import { showIntercomNewMessage } from "../pixelmixer-webapp/src/util/Utils";
import { useDataDog } from "../component/hooks";
import Footer from "../component/footer/Footer";

const PricingPage = ({ nonce }) => {
  useDataDog();
  const [term, setTerm] = useState("yearly");
  return (
    <>
      <SiteHead showNavBar={true} disableFixed={true} nonce={nonce} />
      <div className="page-container">
        {/* <!--===== PRICING PLAN AREA STARTS =======--> */}
        <div className="pricing-plan-section-area pricing2 sp6 bg-none">
          <div className="container">
            <div className="row">
              <div className="col-lg-7 m-auto">
                <div className="pricing-header text-center heading6">
                  <span className="seo">Simple Pricing</span>
                  <div className="space16"></div>
                  <h2 className="text-capitalize">No credit card required.</h2>
                  <h4 className="text-capitalize">
                    Change or cancel your plan at anytime.
                  </h4>
                </div>
              </div>
            </div>
            <div className="space60"></div>
            <div className="pricing-plans">
              <div>
                <div className="row">
                  <div className="col-12 text-center">
                    <div className="plan-toggle-wrap">
                      <div className="toggle-inner">
                        <input
                          id="ce-toggle"
                          type="checkbox"
                          value="yearly"
                          onChange={(e) =>
                            setTerm(term === "monthly" ? "yearly" : "monthly")
                          }
                          checked={term === "yearly"}
                        />
                        <span className="custom-toggle"></span>
                        <span
                          className="t-month"
                          style={{ opacity: term === "monthly" ? 1 : 0.5 }}
                        >
                          Monthly
                        </span>
                        <span
                          className="t-year"
                          style={{ opacity: term === "yearly" ? 1 : 0.5 }}
                        >
                          Annual
                        </span>
                      </div>
                    </div>
                    <div className="space40"></div>
                  </div>
                </div>
                <div className="tab-content">
                  <div
                    id="monthly"
                    style={{ display: term === "monthly" ? "block" : "none" }}
                  >
                    <div className="row">
                      <div className="col-md-6 col-lg-4">
                        <div className="price-box">
                          <div className="heading">
                            <div className="pricing-area">
                              <h3>Starter</h3>
                              <div className="space24"></div>
                              <h2 className="pricing-heading">FREE</h2>
                              <div className="space16"></div>
                              <p>Intelligent Video Workspace</p>
                              <div className="space24"></div>
                              <div>
                                <Link
                                  href="/createAccount"
                                  className="header-btn2"
                                >
                                  Get Started
                                </Link>
                              </div>
                            </div>
                            <div className="price-list">
                              <ul>
                                <li>
                                  <img
                                    src="/static/website-assets/images/icons/check-icons4.svg"
                                    alt=""
                                  />
                                  Up to 5 Users
                                </li>
                                <li>
                                  <img
                                    src="/static/website-assets/images/icons/check-icons4.svg"
                                    alt=""
                                  />
                                  Up to 20 Videos
                                </li>
                                <li>
                                  <img
                                    src="/static/website-assets/images/icons/check-icons4.svg"
                                    alt=""
                                  />
                                  Up to 20 min / video
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 col-lg-4">
                        <div className="price-box">
                          <div className="heading">
                            <div className="pricing-area bg2">
                              <div className="popular">
                                <p>Most Popular</p>
                              </div>
                              <h3>PixelMixer Team</h3>
                              <div className="space24"></div>
                              <h2 className="pricing-heading">
                                $14<span>/user per month</span>
                              </h2>
                              <div className="space16"></div>
                              <p>Knowledge Sharing for Business</p>
                              <div className="space24"></div>
                              <div>
                                <Link
                                  href="/createAccount?accountType=TEAM"
                                  className="header-btn2"
                                >
                                  Choose Team
                                </Link>
                              </div>
                            </div>
                            <div className="price-list">
                              <ul>
                                <li>
                                  <img
                                    src="/static/website-assets/images/icons/check-icons4.svg"
                                    alt=""
                                  />
                                  Up to 50 Users
                                </li>
                                <li>
                                  <img
                                    src="/static/website-assets/images/icons/check-icons4.svg"
                                    alt=""
                                  />
                                  Up to 500 Videos
                                </li>
                                <li>
                                  <img
                                    src="/static/website-assets/images/icons/check-icons4.svg"
                                    alt=""
                                  />
                                  Up to 2 hours / video
                                </li>
                                <li>
                                  <img
                                    src="/static/website-assets/images/icons/check-icons4.svg"
                                    alt=""
                                  />
                                  Meeting Platform Integration
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 col-lg-4">
                        <div className="price-box">
                          <div className="heading">
                            <div className="pricing-area">
                              <h3>Enterprise Plan</h3>
                              <div className="space24"></div>
                              <h2 className="pricing-heading">Let's Talk</h2>
                              <div className="space16"></div>
                              <p>Org-Wide Thought Collaboration</p>
                              <div className="space24"></div>
                              <div>
                                <Link
                                  href="#"
                                  onClick={() =>
                                    showIntercomNewMessage(
                                      "I am interested in an enterprise account."
                                    )
                                  }
                                  className="header-btn2"
                                >
                                  Get In Touch
                                </Link>
                              </div>
                            </div>
                            <div className="price-list">
                              <ul>
                                <li>
                                  <img
                                    src="/static/website-assets/images/icons/check-icons4.svg"
                                    alt=""
                                  />
                                  Unlimited Users + Single Sign-On
                                </li>
                                <li>
                                  <img
                                    src="/static/website-assets/images/icons/check-icons4.svg"
                                    alt=""
                                  />
                                  Unlimited Videos + Multiple Workspaces
                                </li>
                                <li>
                                  <img
                                    src="/static/website-assets/images/icons/check-icons4.svg"
                                    alt=""
                                  />
                                  Unlimited Video Length + Retention Policies
                                </li>
                                <li>
                                  <img
                                    src="/static/website-assets/images/icons/check-icons4.svg"
                                    alt=""
                                  />
                                  API, Topic Management and more.
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    id="yearly"
                    style={{ display: term === "yearly" ? "block" : "none" }}
                  >
                    <div className="row">
                      <div className="col-md-6 col-lg-4">
                        <div className="price-box">
                          <div className="heading">
                            <div className="pricing-area">
                              <h3>Starter</h3>
                              <div className="space24"></div>
                              <h2 className="pricing-heading">FREE</h2>
                              <div className="space16"></div>
                              <p>Intelligent Video Workspace</p>
                              <div className="space24"></div>
                              <div>
                                <Link
                                  href="/createAccount"
                                  className="header-btn2"
                                >
                                  Get Started
                                </Link>
                              </div>
                            </div>
                            <div className="price-list">
                              <ul>
                                <li>
                                  <img
                                    src="/static/website-assets/images/icons/check-icons4.svg"
                                    alt=""
                                  />
                                  Up to 5 Users
                                </li>
                                <li>
                                  <img
                                    src="/static/website-assets/images/icons/check-icons4.svg"
                                    alt=""
                                  />
                                  Up to 20 Videos
                                </li>
                                <li>
                                  <img
                                    src="/static/website-assets/images/icons/check-icons4.svg"
                                    alt=""
                                  />
                                  Up to 20 min / video
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 col-lg-4">
                        <div className="price-box">
                          <div className="heading">
                            <div className="pricing-area bg2">
                              <div className="popular">
                                <p>Most Popular</p>
                              </div>
                              <h3>PixelMixer Team</h3>
                              <div className="space24"></div>
                              <h2 className="pricing-heading">
                                $12<span>/user per month, billed annualy</span>
                              </h2>
                              <div className="space16"></div>
                              <p>Knowledge Sharing for Business</p>
                              <div className="space24"></div>
                              <div>
                                <Link
                                  href="/createAccount?accountType=TEAM"
                                  className="header-btn2"
                                >
                                  Choose Team
                                </Link>
                              </div>
                            </div>
                            <div className="price-list">
                              <ul>
                                <li>
                                  <img
                                    src="/static/website-assets/images/icons/check-icons4.svg"
                                    alt=""
                                  />
                                  Up to 50 Users
                                </li>
                                <li>
                                  <img
                                    src="/static/website-assets/images/icons/check-icons4.svg"
                                    alt=""
                                  />
                                  Up to 500 Videos
                                </li>
                                <li>
                                  <img
                                    src="/static/website-assets/images/icons/check-icons4.svg"
                                    alt=""
                                  />
                                  Up to 2 hours / video
                                </li>
                                <li>
                                  <img
                                    src="/static/website-assets/images/icons/check-icons4.svg"
                                    alt=""
                                  />
                                  Meeting Platform Integration
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6 col-lg-4">
                        <div className="price-box">
                          <div className="heading">
                            <div className="pricing-area">
                              <h3>Enterprise Plan</h3>
                              <div className="space24"></div>
                              <h2 className="pricing-heading">Let's Talk</h2>
                              <div className="space16"></div>
                              <p>Org-Wide Thought Collaboration</p>
                              <div className="space24"></div>
                              <div>
                                <Link
                                  href="#"
                                  onClick={() =>
                                    showIntercomNewMessage(
                                      "I am interested in an enterprise account."
                                    )
                                  }
                                  className="header-btn2"
                                >
                                  Get In Touch
                                </Link>
                              </div>
                            </div>
                            <div className="price-list">
                              <ul>
                                <li>
                                  <img
                                    src="/static/website-assets/images/icons/check-icons4.svg"
                                    alt=""
                                  />
                                  Unlimited Users + Single Sign-On
                                </li>
                                <li>
                                  <img
                                    src="/static/website-assets/images/icons/check-icons4.svg"
                                    alt=""
                                  />
                                  Unlimited Videos + Multiple Workspaces
                                </li>
                                <li>
                                  <img
                                    src="/static/website-assets/images/icons/check-icons4.svg"
                                    alt=""
                                  />
                                  Unlimited Video Length + Retention Policies
                                </li>
                                <li>
                                  <img
                                    src="/static/website-assets/images/icons/check-icons4.svg"
                                    alt=""
                                  />
                                  API, Topic Management and more.
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!--===== PRICING PLAN AREA ENDS =======--> */}

        {/* <!--===== PRICING PLAN AREA STARTS =======--> */}
        <div className="pricing-plan-section-area pricing2 sp3">
          <div className="container">
            <div className="row">
              <div className="col-lg-7 m-auto">
                <div className="pricing-header text-center heading6">
                  <span className="seo">Compare Plans</span>
                  <div className="space16"></div>
                  <h2 className="text-capitalize">Plan Features</h2>
                </div>
              </div>
            </div>
            <div className="space60"></div>
            <div className="pricing-plans compare-plan">
              <div className="row">
                <div className="col-lg-12">
                  <div className="table-area">
                    <table className="price-table">
                      <thead>
                        <tr>
                          <th>
                            <div className="plan-toggle-wrap1 hedaing6"></div>
                            <div className="space40"></div>
                          </th>
                          <th>
                            <div className="tab-content">
                              <div>
                                <h3>Starter</h3>
                                <div className="space24"></div>
                                <Link
                                  href="/createAccount?"
                                  className="header-btn2"
                                >
                                  Get Started
                                </Link>
                              </div>
                            </div>
                          </th>
                          <th>
                            <div className="tab-content bg2">
                              <div>
                                <h3>Team</h3>
                                <div className="space24"></div>
                                <Link
                                  href="/createAccount?accountType=TEAM"
                                  className="header-btn2"
                                >
                                  Choose Team
                                </Link>
                              </div>
                            </div>
                          </th>
                          <th>
                            <div className="tab-content">
                              <div>
                                <h3>Enterprise</h3>
                                <div className="space24"></div>
                                <Link
                                  href="#"
                                  onClick={() =>
                                    showIntercomNewMessage(
                                      "I am interested in an enterprise account."
                                    )
                                  }
                                  className="header-btn2"
                                >
                                  Contact Us
                                </Link>
                              </div>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr className="title-row">
                          <td className="feature-label">Basics</td>
                          <td colSpan="3"></td>
                        </tr>

                        <tr>
                          <td className="feature-label">Account Users</td>
                          <td className="feature-text">
                            <div className="feature-cell">5</div>
                          </td>
                          <td className="feature-text">
                            <div className="feature-cell">50</div>
                          </td>
                          <td className="feature-text">
                            <div className="feature-cell">Unlimited</div>
                          </td>
                        </tr>

                        <tr>
                          <td className="feature-label">Viewers</td>
                          <td className="feature-text">
                            <div className="feature-cell">Unlimited (Free)</div>
                          </td>
                          <td className="feature-text">
                            <div className="feature-cell">Unlimited (Free)</div>
                          </td>
                          <td className="feature-text">
                            <div className="feature-cell">Unlimited (Free)</div>
                          </td>
                        </tr>

                        <tr>
                          <td className="feature-label">Video Length</td>
                          <td className="feature-text">
                            <div className="feature-cell">15 min</div>
                          </td>
                          <td className="feature-text">
                            <div className="feature-cell">2 hours</div>
                          </td>
                          <td className="feature-text">
                            <div className="feature-cell">Unlimited</div>
                          </td>
                        </tr>

                        <tr>
                          <td className="feature-label">Videos</td>
                          <td className="feature-text">
                            <div className="feature-cell">20</div>
                          </td>
                          <td className="feature-text">
                            <div className="feature-cell">500</div>
                          </td>
                          <td className="feature-text">
                            <div className="feature-cell">Unlimited</div>
                          </td>
                        </tr>

                        <tr>
                          <td className="feature-label">Channels</td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/cross-icon1.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td className="feature-label">Playlists</td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/cross-icon1.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td className="feature-label">Workspaces</td>
                          <td className="feature-text">
                            <div className="feature-cell">1</div>
                          </td>
                          <td className="feature-text">
                            <div className="feature-cell">1</div>
                          </td>
                          <td className="feature-text">
                            <div className="feature-cell">Unlimited</div>
                          </td>
                        </tr>

                        <tr className="title-row">
                          <td className="feature-label"></td>
                          <td colSpan="3"></td>
                        </tr>

                        <tr className="title-row">
                          <td className="feature-label">
                            Meeting Intelligence
                          </td>
                          <td colSpan="3"></td>
                        </tr>

                        <tr>
                          <td className="feature-label">
                            Video Transcriptions
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td className="feature-label">40+ Languages</td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/cross-icon1.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td className="feature-label">Vocabulary Training</td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/cross-icon1.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td className="feature-label">
                            Vocabulary Management
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/cross-icon1.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/cross-icon1.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td className="feature-label">Speaker Detection</td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td className="feature-label">
                            Import Zoom, Google Meet, and more
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td className="feature-label">Slack Integration</td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/cross-icon1.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                        </tr>

                        <tr className="title-row">
                          <td className="feature-label"></td>
                          <td colSpan="3"></td>
                        </tr>

                        <tr className="title-row">
                          <td className="feature-label">Highlights</td>
                          <td colSpan="3"></td>
                        </tr>

                        <tr>
                          <td className="feature-label">Summarization</td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/cross-icon1.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td className="feature-label">
                            Action Items and Deliverables
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/cross-icon1.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td className="feature-label">Chapter Detection</td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/cross-icon1.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td className="feature-label">Topic Updates</td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/cross-icon1.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td className="feature-label">Topic Ticker</td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/cross-icon1.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td className="feature-label">Slack Integration</td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/cross-icon1.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                        </tr>

                        <tr className="title-row">
                          <td className="feature-label"></td>
                          <td colSpan="3"></td>
                        </tr>

                        <tr className="title-row">
                          <td className="feature-label">Video Messaging</td>
                          <td colSpan="3"></td>
                        </tr>

                        <tr>
                          <td className="feature-label">
                            Webcam + Screen Recording
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td className="feature-label">
                            Record directly from browser or mobile device
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td className="feature-label">Chrome Extension</td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td className="feature-label">Background Blur</td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td className="feature-label">Emotive Backgrounds</td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td className="feature-label">
                            Multi-screen Recording
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td className="feature-label">Slack Integration</td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/cross-icon1.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                        </tr>

                        <tr className="title-row">
                          <td className="feature-label"></td>
                          <td colSpan="3"></td>
                        </tr>

                        <tr className="title-row">
                          <td className="feature-label">Video Wiki</td>
                          <td colSpan="3"></td>
                        </tr>

                        <tr>
                          <td className="feature-label">Topic Channels</td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/cross-icon1.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td className="feature-label">
                            Topic Detection and Auto-Tagging
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/cross-icon1.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td className="feature-label">Keyword Alerts</td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/cross-icon1.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td className="feature-label">Slack Integration</td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/cross-icon1.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                        </tr>

                        <tr className="title-row">
                          <td className="feature-label"></td>
                          <td colSpan="3"></td>
                        </tr>

                        <tr className="title-row">
                          <td className="feature-label">Collaboration</td>
                          <td colSpan="3"></td>
                        </tr>

                        <tr>
                          <td className="feature-label">
                            Video Comments and Discussions
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td className="feature-label">Timeline Markers</td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td className="feature-label">Likes</td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td className="feature-label">
                            Team + Project Channels
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/cross-icon1.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td className="feature-label">Direct Messaging</td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/cross-icon1.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td className="feature-label">Slack Integration</td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/cross-icon1.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                        </tr>

                        <tr className="title-row">
                          <td className="feature-label"></td>
                          <td colSpan="3"></td>
                        </tr>

                        <tr className="title-row">
                          <td className="feature-label">Security</td>
                          <td colSpan="3"></td>
                        </tr>

                        <tr>
                          <td className="feature-label">
                            Google OAuth Sign-in
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td className="feature-label">
                            SAML Single Sign-on (SSO)
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/cross-icon1.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/cross-icon1.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td className="feature-label">
                            Data Encryption at rest and in transit
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                        </tr>

                        <tr className="title-row">
                          <td className="feature-label"></td>
                          <td colSpan="3"></td>
                        </tr>

                        <tr className="title-row">
                          <td className="feature-label">Compliance</td>
                          <td colSpan="3"></td>
                        </tr>

                        <tr>
                          <td className="feature-label">
                            Custom Retention Policies
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/cross-icon1.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/cross-icon1.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td className="feature-label">
                            Audit and Access Reports
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/cross-icon1.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-text">
                            <div className="feature-cell">Basic ad-hoc</div>
                          </td>
                          <td className="feature-text">
                            <div className="feature-cell">Custom Automated</div>
                          </td>
                        </tr>

                        <tr>
                          <td className="feature-label">Data Export</td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/cross-icon1.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/cross-icon1.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                        </tr>

                        <tr className="title-row">
                          <td className="feature-label"></td>
                          <td colSpan="3"></td>
                        </tr>

                        <tr className="title-row">
                          <td className="feature-label">Administration</td>
                          <td colSpan="3"></td>
                        </tr>

                        <tr>
                          <td className="feature-label">Video Permissions</td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/cross-icon1.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td className="feature-label">Channel Permissions</td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/cross-icon1.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td className="feature-label">Custom Domain Name</td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/cross-icon1.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-text">
                            <div className="feature-cell">Optional</div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td className="feature-label">Domain Claiming</td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/cross-icon1.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/cross-icon1.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td className="feature-label">Account Policies</td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/cross-icon1.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td className="feature-label">
                            Custom Terms of Service
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/cross-icon1.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/cross-icon1.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                        </tr>

                        <tr className="title-row">
                          <td className="feature-label"></td>
                          <td colSpan="3"></td>
                        </tr>

                        <tr className="title-row">
                          <td className="feature-label">Video Embedding</td>
                          <td colSpan="3"></td>
                        </tr>

                        <tr>
                          <td className="feature-label">
                            Embed Videos in Confluence and Websites
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td className="feature-label">
                            Embed Channels in Confluence and Websites
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/cross-icon1.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                        </tr>

                        <tr>
                          <td className="feature-label">
                            Video Links Unfurl in Slack and Teams
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/cross-icon1.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                          <td className="feature-check">
                            <div className="feature-cell">
                              <img
                                src="/static/website-assets/images/icons/check-img6.svg"
                                alt=""
                              />
                            </div>
                          </td>
                        </tr>

                        <tr className="title-row">
                          <td className="feature-label"></td>
                          <td colSpan="3"></td>
                        </tr>

                        <tr className="title-row">
                          <td className="feature-label">Support</td>
                          <td colSpan="3"></td>
                        </tr>

                        <tr>
                          <td className="feature-label">Access to Support</td>
                          <td className="feature-text">
                            <div className="feature-cell">Standard</div>
                          </td>
                          <td className="feature-text">
                            <div className="feature-cell">24/7</div>
                          </td>
                          <td className="feature-text">
                            <div className="feature-cell">
                              24/7 + 4 hour response
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!--===== PRICING PLAN AREA ENDS =======--> */}
      </div>
      <Footer includeSignup={false} />
    </>
  );
};

export default PricingPage;
